{
    "productDashboard": {
        "common": {
            "last": "Ultimele",
            "for": "Pentru",
            "days": "zile",
            "day": "zi",
            "categories": "categorii",
            "open": "Deschis",
            "inProgress": "În curs",
            "inProgressShort": "În curs",
            "resolved": "Rezolvat",
            "clear": "Șterge",
            "selected": "selected",
            "clearAllFilters": "Șterge toate filtrele"
        },
        "shell": {
            "dataUpdated": "Date actualizate",
            "latestTurn": "ultima interacțiune",
            "records": "înregistrări",
            "ofData": "de date",
            "syncing": "Se sincronizează…",
            "refresh": "↻ Reîmprospătează datele",
            "dataRefreshed": "Datele au fost reîmprospătate.",
            "syncFailed": "Sincronizarea nu a putut fi pornită.",
            "syncCompletedWithErrors": "Sincronizare finalizată cu erori:",
            "timeRangeAria": "Interval de timp",
            "overview": "Prezentare generală",
            "myhelpData": "din datele MyHelp",
            "rangeLabel": "Interval",
            "rangeAria": "Interval de date personalizat",
            "rangeFrom": "De la",
            "rangeTo": "Până la",
            "rangeApplyAria": "Aplică intervalul de date",
            "rangeClearAria": "Șterge intervalul de date",
            "rangeSelectBoth": "Selectați atât data de început, cât și cea de sfârșit.",
            "rangeInvalidOrder": "Data de început trebuie să fie înaintea datei de sfârșit.",
            "rangeTooWide": "Selectați un interval de până la",
            "dateRangeCaption": "Interval de date"
        },
        "overview": {
            "greetingMorning": "Bună dimineața",
            "greetingAfternoon": "Bună ziua",
            "greetingEvening": "Bună seara",
            "greetingNight": "Noapte bună",
            "subtitle": "Iată ce se întâmplă astăzi cu produsele dumneavoastră.",
            "tabOverview": "Prezentare generală",
            "tabActionsForYou": "Acțiuni pentru dumneavoastră",
            "actionsTitle": "Acțiuni pentru dumneavoastră",
            "actionsMeta": "Următorii pași recomandați pentru echipa de produs",
            "kpiTotalQueries": "TOTAL SOLICITĂRI",
            "kpiIncidentsRaised": "INCIDENTE RAPORTATE (Din 10 septembrie)",
            "kpiUpcoming": "FUNCȚIE VIITOARE",
            "kpiCallback": "SOLICITĂRI DE APEL ÎnAPOI (Din 10 septembrie)",
            "kpiLiveChat": "SOLICITĂRI DE CHAT LIVE (Din 10 septembrie)",
            "viewBreakdown": "Detalierea →",
            "viewAllIncidents": "Toate incidentele →",
            "upcomingTitle": "Funcție nouă în curând",
            "upcomingSub": "Mai multe informații despre produse vor fi disponibile în curând.",
            "topCategories": "Principalele categorii de solicitări",
            "viewAll": "Vezi tot →",
            "tipQueries": "Solicitări",
            "uniqueUsersTitle": "Utilizatori unici",
            "detailedView": "Vizualizare detaliată",
            "usersPerDay": "Utilizatori unici pe zi",
            "usersPerWeek": "Utilizatori unici pe săptămână",
            "usersPerMonth": "Utilizatori unici pe lună",
            "uniqueUsersTrendTooltipLead": "Compară",
            "uniqueUsersTrendTooltipConnector": "cu",
            "kpiTooltips": {
                "totalQueries": "Numărul total de solicitări primite pentru toate produsele în intervalul de timp selectat.",
                "incidentsRaised": "Incidente raportate din conversațiile cu chatbotul, defalcate pe status.",
                "upcoming": "O nouă funcție a tabloului de bord este pe drum — reveniți în curând.",
                "callback": "Solicitări de apel înapoi trimise de utilizatori, defalcate pe limbă.",
                "liveChat": "Solicitări de chat live trimise de utilizatori, defalcate pe limbă.",
                "feedbackCoverage": "Procentul din totalul solicitărilor care au primit feedback din partea utilizatorilor (👍 sau 👎)."
            }
        },
        "totalQueries": {
            "title": "Analiza totalului de solicitări",
            "queries": "solicitări",
            "vsPrior": "față de perioada anterioară",
            "chartTitle": "Solicitări pe categorie",
            "breakdownTitle": "Detaliere pe categorii",
            "thCategory": "CATEGORIE",
            "thQueries": "SOLICITĂRI",
            "thShare": "PONDERE",
            "thDistribution": "DISTRIBUȚIE",
            "tipQueries": "Solicitări",
            "tipShare": "Pondere %",
            "searchPlaceholder": "Căutare",
            "matchesSuffix": "rezultate",
            "matchSuffix": "rezultat"
        },
        "incidents": {
            "title": "Categorii de probleme",
            "incidents": "incidente",
            "thId": "ID",
            "thIssue": "SOLICITARE / PROBLEMĂ",
            "thCategory": "CATEGORIE",
            "thProduct": "PRODUS",
            "thCompany": "COMPANIE",
            "thSeverity": "SEVERITATE",
            "thStatus": "STARE",
            "empty": "Niciun incident MyHelp în această perioadă.",
            "severityHigh": "Ridicată",
            "severityMedium": "Medie",
            "severityLow": "Scăzută",
            "incident": "incident",
            "breakdownTitle": "Detaliere pe categorie",
            "thIncidents": "INCIDENTE",
            "thShare": "PONDERE",
            "thDistribution": "DISTRIBUŢIE",
            "searchPlaceholder": "Căutare",
            "matchesSuffix": "rezultate",
            "matchSuffix": "rezultat"
        },
        "incidentCategory": {
            "titlePrefix": "Incidente în",
            "loadError": "Nu s-au putut încărca incidentele.",
            "incident": "incident",
            "incidents": "incidente",
            "closeAria": "Închide",
            "thDate": "DATA",
            "empty": "Nu s-au găsit incidente pentru această categorie.",
            "loading": "Se încarcă…",
            "loadMorePrefix": "Încarcă mai multe (afișate",
            "of": "din"
        },
        "userSentiment": {
            "title": "Analiza feedback-ului utilizatorilor",
            "summaryLikes": "aprecieri",
            "summaryDislikes": "aprecieri negative",
            "last": "Ultimele",
            "days": "zile",
            "likes": "Aprecieri",
            "dislikes": "Aprecieri negative",
            "chartTitle": "Aprecieri vs. aprecieri negative pe categorie",
            "detailTitle": "Detalii feedback pe categorie",
            "positive": "Pozitiv",
            "thingsWell": "Ce a mers bine",
            "thingsAttention": "Ce necesită atenție",
            "askAiHint": "Întreabă asistentul AI despre asta (se deschide într-o filă nouă)",
            "searchPlaceholder": "Căutare",
            "matchesSuffix": "rezultate",
            "matchSuffix": "rezultat"
        },
        "products": {
            "title": "Categorii de produse",
            "products": "produse",
            "queryVolume": "Volum de solicitări",
            "incidents": "Incidente",
            "sentiment": "Sentiment",
            "healthScore": "Scor de sănătate"
        },
        "companyFilter": {
            "allCompanies": "Toate companiile",
            "allCompaniesShort": "Toate companiile",
            "selectedSuffix": "companii selectate",
            "filterAria": "Filtrează după companie",
            "searchPlaceholder": "Caută companii…",
            "noMatchPrefix": "Nicio companie nu corespunde"
        },
        "clusterFilter": {
            "allClusters": "Toate clusterele",
            "allClustersShort": "Toate clusterele",
            "selectedSuffix": "clustere selectate",
            "filterAria": "Filtrează după cluster",
            "searchPlaceholder": "Caută clustere…",
            "noMatchPrefix": "Niciun cluster nu corespunde"
        },
        "categoryFilter": {
            "allCategories": "Toate categoriile",
            "selectedSuffix": "categorii selectate",
            "filterAria": "Filtrare după categorie",
            "searchPlaceholder": "Caută categorii…",
            "allCategoriesShort": "Toate categoriile",
            "selectedShort": "selectate",
            "clear": "Șterge",
            "noMatchPrefix": "Nicio categorie nu corespunde cu"
        },
        "categoryQueries": {
            "like": "Apreciază",
            "dislike": "Nu apreciază",
            "titlePrefix": "Solicitări în",
            "loadError": "Solicitările nu au putut fi încărcate.",
            "query": "solicitare",
            "queries": "solicitări",
            "preparing": "Se pregătește…",
            "downloadExcel": "⬇ Descarcă Excel",
            "closeAria": "Închide",
            "thQuery": "SOLICITARE",
            "thSentiment": "SENTIMENT",
            "thDate": "DATA",
            "thSource": "SURSĂ",
            "thLanguage": "LIMBĂ",
            "thCompany": "COMPANIE",
            "colQuery": "Solicitare",
            "colSentiment": "Sentiment",
            "colDate": "Data",
            "colSource": "Sursă",
            "colLanguage": "Limbă",
            "colCompany": "Companie",
            "empty": "Nu s-au găsit solicitări pentru această categorie.",
            "loading": "Se încarcă…",
            "loadMorePrefix": "Încarcă mai multe (se afișează",
            "of": "din",
            "sortSentimentHint": "Clic pentru a sorta după sentiment",
            "sortDateHint": "Clic pentru a sorta după dată"
        },
        "feedbackPie": {
            "likes": "Aprecieri",
            "dislikes": "Aprecieri negative",
            "noFeedback": "Niciun feedback",
            "coverage": "ACOPERIRE FEEDBACK",
            "meta": "din totalul solicitărilor",
            "feedback": "feedback",
            "noData": "Nicio dată",
            "viewFeedback": "Feedback-ul utilizatorilor →"
        },
        "requestCard": {
            "empty": "Nicio solicitare în această perioadă.",
            "breakdown": "Detaliere →"
        },
        "requestBreakdown": {
            "titleCallback": "Solicitări de apel — Detaliere pe limbă",
            "titleLiveChat": "Solicitări chat live — Detaliere pe limbă",
            "breakdownTitle": "Detaliere pe limbă",
            "thLanguage": "LIMBĂ",
            "thCount": "NUMĂR",
            "thShare": "PONDERE",
            "thDistribution": "DISTRIBUŢIE",
            "language": "limbă",
            "languages": "limbi",
            "request": "solicitare",
            "requests": "solicitări",
            "empty": "Nicio solicitare în această perioadă."
        },
        "tabError": {
            "title": "Datele tabloului de bord nu au putut fi încărcate",
            "message": "Serviciul de date nu a răspuns. Vă rugăm să reîncercați — nu sunt afișate date, așa că nimic de aici nu este estimat."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Creează / actualizează articole din baza de cunoștințe",
                "hint": "Menține conținutul produsului dumneavoastră corect și actualizat",
                "childTitle": "Crearea și actualizarea bazei de cunoștințe",
                "childHint": "Cum se creează și se actualizează baza de cunoștințe."
            },
            "scripts": {
                "title": "Construiește și implementează scripturi prin Nexthink Remote Actions",
                "hint": "Automatizează rezolvarea problemei prin activarea unei acțiuni la distanță pe dispozitivul utilizatorului",
                "childTitle": "Link pentru comandarea Nexthink",
                "childHint": "Gestionarea acțiunilor la distanță"
            }
        }
    }
}
